<nav class="navigation-bar">
  <div class="nav-container">
    <!-- Left side: App title -->
    <div class="nav-left">
      <h1 class="app-title"></h1>
    </div>

    <!-- Right side: Authentication info -->
    <div class="nav-right">
      <!-- Authentication Status -->
      <div class="auth-status" [class]="getAuthStatusClass()">
        <span class="status-icon">
          <span *ngIf="!isAuthenticated || isTokenExpired">🔒</span>
          <span *ngIf="isAuthenticated && !isTokenExpired">🔓</span>
        </span>
        <span class="status-text">{{ getAuthStatus() }}</span>
      </div>

      <!-- Username Display -->
      <div class="username-display" *ngIf="username">
        <span class="username-label">用戶:</span>
        <span class="username-value">{{ username }}</span>
      </div>

      <!-- Session Expired Message -->
      <div class="session-expired" *ngIf="isAuthenticated && isTokenExpired">
        <span class="expired-icon">⚠️</span>
        <span class="expired-text">{{ getSessionExpiredMessage() }}</span>
      </div>

      <!-- Login/Switch Admin Button -->
      <button class="login-btn" (click)="login()" [class.login-expired]="!isAuthenticated || isTokenExpired">
        {{ getLoginButtonText() }}
      </button>
    </div>
  </div>
</nav> 